import { isObjectType } from 'graphql';
import buildClientSchemaFromIntrospection from './buildClientSchemaFromIntrospection.js';
import getPathSegments from './getPathSegments.js';
import unwrapFieldType from './unwrapFieldType.js';

const getFieldPathState = (schema, path) => {
  if (!schema || !path) {
    return null;
  }

  const clientSchema = buildClientSchemaFromIntrospection(schema);
  let currentType = clientSchema?.getQueryType();

  if (!currentType) {
    return null;
  }

  const traversedFields = [];

  for (const segment of getPathSegments(path)) {
    if (!isObjectType(currentType)) {
      return null;
    }

    const field = currentType.getFields()[segment];

    if (!field) {
      return null;
    }

    traversedFields.push(field);
    currentType = unwrapFieldType(field.type).type;
  }

  return {
    clientSchema,
    currentType,
    traversedFields
  };
};

export default getFieldPathState;
